<template>
    <div id="tooltip" ref="tool" class="calendar_tooltip"
         :style="{bottom: bottom +'px', left: left+'px'}"
    >
        <div v-for="(item, index) in actual_date" :key="index" class="calendar_tooltip__cont">
            <div class="calendar_tooltip__item">
                <div class="calendar_tooltip__datas">
                </div>
                <div class="calendar_tooltip__link">
                    <div class="calendar_points">
                        <div class="calendar_point__icon">
                            <svg v-svg
                                 symbol="schedule"
                                 class="study__icon study__icon-grey mr-0"
                                 role="presentation"
                            />
                        </div>
                        <div class="calendar_point__item" style="cursor: pointer;">
                            {{ item.date_assigned }} - {{ item.date_expired }}
                        </div>
                    </div>
                    <router-link :to="item.url">
                        <div class="link calendar_link link--red mb-3" @click="CLOSE_CALENDAR()">
                            {{ item.title }}
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);
export default {
  props   : ['day', 'left', 'bottom'],
  computed: {
    ...mapGetters('calendar', ['calendar_date', 'show_flag', 'actual_date']),
  },
  mounted() {
    this.$emit('el', this.$el);
  },
  methods: {
    ...mapMutations('calendar', ['TOGGLE_CALENDAR', 'CLOSE_CALENDAR', 'SET_CALENDAR_DATES', 'CHECK_DATE_FOR_VISUAL', 'RESET_ACTUAL_DATES']),
  },
};
</script>
